import { call, put, select, takeLatest } from 'redux-saga/effects'
import { push } from 'react-router-redux'
import request from 'shared/services/networking'
import find from 'lodash/find'
import groupElementsByKeys from 'shared/services/groupElementsByKeys'
import { getCompanySelector, setSelectedProduct } from 'shared/pages/Company/module'
import { resetBreadcrumbElements, popLastBreadcrumbElement, pushBreadcrumbElement } from 'shared/components/Breadcrumb/module'
import { SEARCH_RESULTS_ROUTE } from 'shared/services/routes'

export const GET_SEARCHBAR_RESULTS_REQUEST = 'SearchBar/GET_SEARCHBAR_RESULTS_REQUEST'
export const GET_SEARCHBAR_RESULTS_SUCCESS = 'SearchBar/GET_SEARCHBAR_RESULTS_SUCCESS'
export const GET_SEARCHBAR_RESULTS_ERROR = 'SearchBar/GET_SEARCHBAR_RESULTS_ERROR'

export const SELECT_SEARCH_RESULT = 'SearchBar/SELECT_SEARCH_RESULT'

export const RESET_SEARCH_RESULTS = 'SearchBar/RESET_SEARCH_RESULTS'

export const REDIRECT_TO_RESULTS_PAGE = 'SearchBar/REDIRECT_TO_RESULTS_PAGE'

export function getSearchBarResultsRequest (query) {
  return {
    type: GET_SEARCHBAR_RESULTS_REQUEST,
    payload: { query }
  }
}

export function getSearchBarResultsSuccess (results) {
  return {
    type: GET_SEARCHBAR_RESULTS_SUCCESS,
    payload: { results }
  }
}

export function getSearchBarResultsError (error) {
  return {
    type: GET_SEARCHBAR_RESULTS_ERROR,
    payload: { error }
  }
}

export function selectSearchResult (id, name, type) {
  return {
    type: SELECT_SEARCH_RESULT,
    payload: { id, name, type }
  }
}

export function resetSearchResults () {
  return {
    type: RESET_SEARCH_RESULTS
  }
}

export function redirectToResultsPage () {
  return {
    type: REDIRECT_TO_RESULTS_PAGE
  }
}

export const getGroupedResults = state => {
  const keys = [{keyName: 'groupTitle', pathToKey: 'widget_type'}]
  return groupElementsByKeys(state.searchBar.results, keys)
}

export const setGroupedResultsKey = groupedResults => {
  const keyValueMap = [
    {key: 'catalog', value: 'Informations générales'},
    {key: 'article', value: 'Articles'},
    {key: 'diagnostic', value: 'Diagnostic'}
  ]

  const allowedGroups = keyValueMap.map(keyValue => keyValue.key)
  return (groupedResults.filter((group) => allowedGroups.includes(group.groupTitle))
    .map(group => (
      {...group,
        groupTitle: find(keyValueMap, {'key': group.groupTitle}).value
      })
    ))
}

export function * redirectToResultsPageGenerator (action) {
  yield put(popLastBreadcrumbElement())
  yield put(pushBreadcrumbElement('Résultats de la recherche', SEARCH_RESULTS_ROUTE))
  yield put(push(SEARCH_RESULTS_ROUTE))
}

export function * getSearchBarResults (action) {
  const query = action.payload.query
  if (query) {
    const company = yield select(getCompanySelector)
    const config = {
      method: 'get',
      params: {
        company: company.id,
        name: query
      },
      url: `${process.env.REACT_APP_API_URL}/widget/`
    }
    try {
      const results = yield call(request, config)
      yield put(getSearchBarResultsSuccess(results))
    } catch (error) {
      yield put(getSearchBarResultsError(error))
    }
  }
}

export function * handleResultSelection (action) {
  const { id, name, type } = action.payload
  const route = `/portal/${type}/${id}`
  yield put(setSelectedProduct(null))
  yield put(resetBreadcrumbElements())
  yield put(pushBreadcrumbElement(name, route))
  yield put(push(route))
}

export function * getSearchBarResultsSaga () {
  yield takeLatest(GET_SEARCHBAR_RESULTS_REQUEST, getSearchBarResults)
}

export function * handleResultSelectionSaga () {
  yield takeLatest(SELECT_SEARCH_RESULT, handleResultSelection)
}

export function * redirectToResultsPageSaga () {
  yield takeLatest(REDIRECT_TO_RESULTS_PAGE, redirectToResultsPageGenerator)
}

const initialState = {
  isNoResultsVisible: false,
  query: null,
  results: []

}

/**
 * Following the duck pattern, the module.js file should export a reducer as a default function
 */
export function reducer (state = initialState, action) {
  switch (action.type) {
    case GET_SEARCHBAR_RESULTS_REQUEST:
      return {
        ...state,
        query: action.payload.query,
        results: action.payload.query === '' ? [] : state.results
      }
    case GET_SEARCHBAR_RESULTS_SUCCESS:
      return {
        ...state,
        isNoResultsVisible: action.payload.results.length === 0,
        results: action.payload.results
      }
    case GET_SEARCHBAR_RESULTS_ERROR:
      return {
        ...state,
        error: action.payload.error
      }
    case SELECT_SEARCH_RESULT:
      return {
        ...state,
        isNoResultsVisible: false,
        results: []
      }
    case RESET_SEARCH_RESULTS:
      return {
        ...state,
        isNoResultsVisible: false,
        results: []
      }
    default:
      return state
  }
}

export default reducer
